import React from 'react';
import { Icon, Button, message, Progress } from 'antd';
import { getUpToken, toUpload } from '@/fetch/api/personal';
import PropTypes from 'prop-types';
import { Decrypt } from '@/utils/encrypt';
import { guid } from '@/utils/validate';
import moment from 'moment';
import './style.less';
var accessid = "",
    accesskey = "",
    host = "",
    policyBase64 = "",
    signature = "",
    callbackbody = "",
    filename = "",
    key = "",
    expire = 0,
    g_object_name = "",
    g_object_name_type = "local_name",
    serverUrl = "",
    suffix = "",
    now = Date.parse(new Date()) / 1000;

function send_request(server) {
  var xmlhttp = null;

  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else if (window.ActiveXObject) {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }

  if (xmlhttp != null) {
    // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
    // serverUrl = 'http://dev.api.yunduoweike.cn/outside/upload';
    // serverUrl = `${window.location.origin}/ns-api/outside/upload`;
    if (server == "course") {
      serverUrl = `${window.location.origin}/s/api/course/upload`; // serverUrl = `http://dev.api.yunduoweike.cn/course/upload`;
    } else {
      serverUrl = `${window.location.origin}/s/api/outside/upload`; // serverUrl = 'http://dev.api.yunduoweike.cn/outside/upload';
    }

    xmlhttp.open("GET", serverUrl, false);
    xmlhttp.send(null);
    return xmlhttp.responseText;
  } else {
    alert("Your browser does not support XMLHTTP.");
  }
}

function get_signature(server) {
  // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
  now = Date.parse(new Date()) / 1000; // if (expire < now + 3) {
  //   var body = send_request(server);
  //   console.log('body:', body);
  //   // var obj = body.code ? eval(`(${body})`).data : {};
  //   var obj = eval("(" + body + ")").data;
  //   console.log(obj);
  //   if (server == "course") {
  //     host = "http://" + obj["host"];
  //   } else {
  //     host = obj["host"];
  //   }
  //   // host = obj["host"];
  //   policyBase64 = obj["policy"];
  //   accessid = obj["accessid"];
  //   signature = obj["signature"];
  //   expire = parseInt(obj["expire"]);
  //   callbackbody = obj["callback"];
  //   key = obj["dir"];
  //   return true;
  // }

  return true;
}

function random_string(len) {
  len = len || 32;
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var pwd = "";

  for (i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
}

function get_suffix(filename) {
  //获取文件后缀
  var pos = filename.lastIndexOf(".");
  suffix = "";

  if (pos != -1) {
    suffix = filename.substring(pos);
  }

  return suffix;
}

function calculate_object_name(filename) {
  if (g_object_name_type == "local_name") {
    g_object_name += "${filename}";
  } else if (g_object_name_type == "random_name") {
    suffix = get_suffix(filename);
    g_object_name = key + random_string(10) + suffix;
  }

  return "";
}

function get_uploaded_object_name(filename) {
  if (g_object_name_type == "local_name") {
    var tmp_name = g_object_name;
    tmp_name = tmp_name.replace("${filename}", filename);
    return tmp_name;
  } else if (g_object_name_type == "random_name") {
    return g_object_name;
  }
}

function set_upload_param(up, filename, ret, server) {
  if (ret == false) {
    ret = get_signature(server);
  } // g_object_name = key;
  // if (filename != "") {
  //   suffix = get_suffix(filename);
  //   calculate_object_name(filename);
  // }
  // var new_multipart_params = {
  //   key: g_object_name,
  //   policy: policyBase64,
  //   OSSAccessKeyId: accessid,
  //   success_action_status: "200", //让服务端返回200,不然，默认会返回204
  //   callback: callbackbody,
  //   signature: signature
  // };
  // console.log(host, "host=======")
  // up.setOption({
  //   url: host,
  //   multipart_params: new_multipart_params
  // });


  up.start();
}

export default class QiniuUpload extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    // 容器id
    children: PropTypes.any,
    // 容器内容
    handleBeforeUpload: PropTypes.func,
    // 上传前处理
    handleFilesAdded: PropTypes.func,
    // 上传中处理
    handlePercent: PropTypes.func,
    // 获取进度条
    handleFileUploaded: PropTypes.func,
    // 上传完成处理
    handleUploadFlag: PropTypes.func,
    // 判断文件是否全部上传完
    fileSize: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      qndomain: '',
      uptoken: '',
      isPress: false,
      percent: 0
    };
  }

  componentDidMount() {
    var _this = this;

    var uploader = new plupload.Uploader({
      runtimes: "html5,flash,silverlight,html4",
      browse_button: this.props.id,
      multi_selection: false,
      container: document.getElementById(`container${this.props.id}`),
      // flash_swf_url: "ali_oss/js/Moxie.swf",
      // silverlight_xap_url: "ali_oss/js/Moxie.xap",
      // url: "http://oss.aliyuncs.com",
      url: "/saas/upload/image",
      filters: {
        mime_types: [//只允许上传图片
        {
          title: "Image files",
          extensions: "jpg,gif,png,bmp,jpeg"
        }],
        max_file_size: this.props.fileSize ? this.props.fileSize : "5mb",
        //最大只能上传5mb的文件
        prevent_duplicates: false //不允许选取重复文件

      },
      init: {
        PostInit: function () {
          console.log("oss init..");
          set_upload_param(uploader, "", false, _this.props.server);
        },
        FilesAdded: function (up, files) {
          this.props.handleUploadFlag && this.props.handleUploadFlag(false, files.length);
          plupload.each(files, function (file) {
            console.log(file, 'FilesAdded--');

            if (file.name.length > 104) {
              message({
                type: 'warning',
                message: '图片名称过长'
              });
              return false;
            }

            this.props.handleFilesAdded && this.props.handleFilesAdded(file, uploader);
            set_upload_param(uploader, "", false, _this.props.server);
          });

          if (this.props.id.indexOf("insteadFillUploadFile") != -1) {
            this.setState({
              isPress: true,
              percent: 0
            });
          }
        },
        BeforeUpload: function (up, file) {
          set_upload_param(up, file.name, true);
          this.props.handleBeforeUpload && this.props.handleBeforeUpload(up, file, uploader);
        },
        UploadProgress: function (up, file) {
          this.props.handlePercent && this.props.handlePercent(file.id, file.percent);

          if (this.props.id.indexOf("insteadFillUploadFile") != -1) {
            this.setState({
              percent: file.percent
            });
          }
        },
        FileUploaded: (up, file, info) => {
          console.log(info, 'info===');

          try {
            var obj = JSON.parse(info);

            if (typeof obj == 'object' && obj) {
              var res = JSON.parse(info);
            } else {
              message({
                type: 'warning',
                message: '上传失败，请重新上传'
              });
            }
          } catch (e) {
            console.log('response返回格式错误，不是json');
            message({
              type: 'warning',
              message: '上传失败，请重新上传'
            });
          } // if (info.status == 200) {


          var id = this.props.fieldId ? this.props.fieldId : "";
          this.props.handleFileUploaded && this.props.handleFileUploaded(file, res, uploader, id);
          this.setState({
            isPress: false
          });
          console.log('上传成功', res); //   return
          // }
          // message.destroy()
          // message.error(res.message);
        },
        FileUploaded: function (up, file, info) {
          console.log(info, 'info===');

          try {
            var obj = JSON.parse(info.response);

            if (typeof obj == 'object' && obj) {
              var res = JSON.parse(info.response);
            } else {
              message({
                type: 'warning',
                message: '上传失败，请重新上传'
              });
              return false;
            }
          } catch (e) {
            console.log('response返回格式错误，不是json');
            message({
              type: 'warning',
              message: '上传失败，请重新上传'
            });
            return false;
          } // if (info.status == 200) {


          var id = this.props.fieldId ? this.props.fieldId : "";
          this.props.handleFileUploaded && this.props.handleFileUploaded(file, res, uploader, id);
          this.setState({
            isPress: false
          });
          console.log('上传成功', res); //   return
          // }
          // message.destroy()
          // message.error(res.message);
        },
        Error: function (up, err) {
          console.log("aliosserr", err);

          if (err.code == -600) {
            message.destroy();
            message.error("图片不能大于2MB");
            return;
          }

          if (err.code == -601) {
            message.destroy();
            message.error("上传失败！");
            return;
          }

          if (err.code == -602) {
            message.destroy();
            message.error("文件上传重复");
            return;
          }

          console.log(err.response);
        }
      }
    });
    uploader.init(); //   // ----------------------------------
    //   Promise.all([this.initSign(),  this.initDomain()]).then(values => {
    //     this.setState({
    //       uptoken: values[0],
    //       qndomain: values[1],
    //     }, () => {
    //       this.initUploader(values[0], values[1]);
    //     })
    //   })
    // }
    // initSign = async () => {
    //   let str = 0
    //   const domain = window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://hxkht.dev.yunduoketang.cn';
    //   await getUpToken(domain).then(res => {
    //     if (res.code === '1') {
    //       str = res.data.uptoken
    //     }
    //   }).catch(
    //     err => Promise.reject(err)
    //   )
    //   return str
    // };
    // initDomain = async () => {
    //   let str = 0
    //   const domain = window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://hxkht.dev.yunduoketang.cn'
    //   await toUpload(domain).then(res => {
    //     console.log('initDomain',res);
    //     if (res.code === '1') {
    //       str = res.data.qndomain
    //     }
    //   }).catch(
    //     err => Promise.reject(err)
    //   )
    //   return str
    // };
    // initUploader = (uptoken, domain) => {
    //   var uploader = Qiniu.uploader({
    //     runtimes: "html5,flash,silverlight,html4", // 上传模式，依次退化
    //     browse_button: this.props.id, // 上传选择的点选按钮，必需
    //     uptoken,
    //     domain, // bucket域名，下载资源时用到，必需
    //     multi_selection: true,
    //     container: document.getElementById(`container${this.props.id}`),  // 上传区域DOM ID，默认是browser_button的父元素
    //     flash_swf_url: "ali_oss/js/Moxie.swf",  //引入flash，相对路径
    //     silverlight_xap_url: "ali_oss/js/Moxie.xap",
    //     filters: {
    //       mime_types:[//：pdf、doc、xls、ppt、doxc、xlsx、pptx、jpg、png、gif
    //         {title:"all files",extensions:"pdf,doc,txt,ppt,docx,xlsx,pptx,jpg,png,gif,jpeg,zip,rar"}
    //       ]
    //     },
    //     get_new_uptoken: true, // 设置上传文件的时候是否每次都重新获取新的uptoken
    //     unique_names: false, // 默认false，key为文件名。若开启该选项，JS-SDK会为每个文件自动生成key（文件名）
    //     save_key: false, // 默认false。若在服务端生成uptoken的上传策略中指定了sava_key，则开启，SDK在前端将不对key进行任何处理
    //     max_file_size: this.props.fileSize?this.props.fileSize:'1024mb', // 最大文件体积限制
    //     max_retries: 3, // 上传失败最大重试次数
    //     chunk_size: '4mb', // 分块上传时，每块的体积
    //     auto_start: true, // 选择文件后自动上传，若关闭需要自己绑定事件触发上传
    //     init: {
    //       // PostInit: function() {
    //       //   console.log("oss init..");
    //       // },
    //       FilesAdded: (up, files) => {
    //         console.log('上传中', files)
    //         this.props.handleUploadFlag && this.props.handleUploadFlag(false, files.length)
    //         plupload.each(files, file => {
    //           this.props.handleFilesAdded && this.props.handleFilesAdded(file, uploader)
    //         });
    //         if(this.props.id.indexOf("insteadFillUploadFile") != -1){
    //           this.setState({
    //             isPress: true,
    //             percent: 0
    //           })
    //         }
    //       },
    //       BeforeUpload: (up, file) => { // 文件上传前判断
    //         this.props.handleBeforeUpload && this.props.handleBeforeUpload(up, file, uploader)
    //       },
    //       Key: (up,file) => {
    //         var companyId = localStorage.getItem('userInfo') ? JSON.parse(Decrypt(localStorage.getItem('userInfo'))).companyId:""
    //         var name = file.name;
    //         var suffix = name.substring(parseInt(name.lastIndexOf(".")+1));
    //         var key = "";
    //         var date = moment(new Date()).format('YYYY-MM-DD');
    //         key = `${companyId}/${date}/coldatatypefile/${guid()}.${suffix}`;
    //         console.log(8888, key)
    //         return key
    //       },
    //       UploadProgress: (up, file) => { // 文件上传进度
    //         this.props.handlePercent && this.props.handlePercent(file.id, file.percent)
    //         if(this.props.id.indexOf("insteadFillUploadFile") != -1){
    //           this.setState({
    //             percent: file.percent
    //           })
    //         }
    //       },
    //       UploadComplete: (up, file, info) => { // 队列文件处理完毕后，处理相关的事情
    //         this.props.handleUploadFlag && this.props.handleUploadFlag(true)
    //       },
    //       FileUploaded: (up, file, info) => {
    //         console.log(info, 'info===')
    //         try {
    //           var obj = JSON.parse(info);
    //           if (typeof obj == 'object' && obj) {
    //             var res = JSON.parse(info);
    //           } else {
    //             message({
    //               type: 'warning',
    //               message: '上传失败，请重新上传'
    //             })
    //           }
    //         } catch (e) {
    //           console.log('response返回格式错误，不是json');
    //           message({
    //             type: 'warning',
    //             message: '上传失败，请重新上传'
    //           })
    //         }
    //         // if (info.status == 200) {
    //           var id=this.props.fieldId?this.props.fieldId:"";
    //           this.props.handleFileUploaded && this.props.handleFileUploaded(file, res, uploader,id)
    //           this.setState({
    //             isPress: false
    //           })
    //           console.log('上传成功', res)
    //         //   return
    //         // }
    //         // message.destroy()
    //         // message.error(res.message);
    //       },
    //       Error: function(up, err) {
    //         console.log("aliosserr", err);
    //         if (err.code == -600) {
    //           message.destroy();
    //           message.error("图片不能大于2MB");
    //           return
    //         }
    //         if (err.code == -601) {
    //           message.destroy();
    //           message.error("上传失败！");
    //           return;
    //         }
    //         if (err.code == -602) {
    //           message.destroy();
    //           message.error("文件上传重复");
    //           return;
    //         }
    //         console.log(err.response);
    //       }
    //     }
    //   });
  }

  render() {
    const {
      children,
      id
    } = this.props;

    const renderHtml = () => {
      if (this.props.progress) {
        return this.state.isPress ? <Progress data-inspector-line="494" data-inspector-column="29" data-inspector-relative-path="src\\components\\QiniuUpload\\index.jsx" percent={this.state.percent} size="small" /> : children;
      } else {
        return children;
      }
    };

    return <div data-inspector-line="502" data-inspector-column="6" data-inspector-relative-path="src\\components\\QiniuUpload\\index.jsx" className="container" id={`container${this.props.id}`}>
        <div data-inspector-line="503" data-inspector-column="8" data-inspector-relative-path="src\\components\\QiniuUpload\\index.jsx" id={id} style={{
        width: '100%',
        height: '100%'
      }}>
          {renderHtml()}
          {
          /* {children} */
        }
        </div>
      </div>;
  }

}